<template>
    <el-table :data="sites" border>
        <el-table-column align="center" label="施工点名称" prop="siteName" />
        <el-table-column align="center" label="账号" prop="mobile" />
        <el-table-column align="center" label="施工点地址">
            <template slot-scope="scope">
                {{
                scope.row.location || '--'
                }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="enable">
            <template slot-scope="scope">
                {{
                ENABLE[scope.row.enable]
                }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="action" width="250">
            <template slot-scope="scope">
                <el-button @click="clickEdit(scope.row)" size="mini">编辑</el-button>
                <el-button
                    @click="clickEnable(scope.row)"
                    size="mini"
                    type="danger"
                >{{ enableMap[scope.row.enable] }}</el-button>
                <router-link
                    :to="{
                        path: ROUTER_SITE_DEVICE,
                        query: {
                            siteId: scope.row.siteId,
                            siteName: scope.row.siteName,
                        },
                    }"
                    style="margin-left: 10px;"
                    target="_blank"
                >
                    <el-button size="mini">设备管理</el-button>
                </router-link>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ROUTER_SITE_DEVICE } from '../../router.js';
import {
    DIALOG_EDIT,
    ENABLE,
    ENABLE_TRUE,
    ENABLE_FALSE,
} from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('site');

export default {
    data() {
        return {
            ROUTER_SITE_DEVICE,
            ENABLE,
            enableMap: {
                [ENABLE_TRUE]: '启用',
                [ENABLE_FALSE]: '禁用',
            },
        };
    },
    computed: {
        ...mapState({
            sites: state => state.sites,
        }),
    },
    methods: {
        ...mapActions(['changeDialog', 'changeForm', 'enableSite']),
        clickEdit(data) {
            const location = data.location.split(',');
            const site = {
                siteId: data.siteId,
                name: data.siteName,
                mobile: data.mobile,
                city: location.slice(0, 3),
                address: location.slice(-1)[0],
            };
            this.changeForm(site);
            this.changeDialog({ type: DIALOG_EDIT, visible: true });
        },
        clickEnable({ siteId, enable }) {
            const text = this.enableMap[enable];
            this.$confirm(`是否要${text}账号？`, '提示', {
                type: 'warning',
            })
                .then(async () => {
                    await this.enableSite({ siteId, enable: enable ? 0 : 1 });
                    this.$message.success(`${text}成功！`);
                })
                .catch(() => {
                    this.$message.info(`取消${text}`);
                });
        },
    },
};
</script>

<style></style>
